import { createFileRoute } from '@tanstack/react-router'
import { SiteTemplatesSection } from '../../../features/service/sites/templates-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/service-site-templates')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'service-site-templates'),
  component: SiteTemplatesSection,
})
